import type { Channel } from '../types'

import type { Actions } from './actions'
import type { Slice } from './slice'
import { SLICE_KEY } from './slice'

/**
 * Fetch channel actions
 */
export function channelActionsSelector(state: Slice): Actions {
  return state[SLICE_KEY]?.actions
}

/**
 * Fetch business status by channel username or encoded ID.
 */
export function channelBusinessActiveSelector(identifier?: string) {
  return (state: Slice): boolean | undefined => {
    if (!identifier) {
      return undefined
    }
    return state[SLICE_KEY]?.businessActiveByIdentifier[identifier]
  }
}

/**
 * Fetch channel by username
 */
export function channelByUsernameSelector(username: string) {
  return (state: Slice): Channel | undefined => {
    return Object.values(state[SLICE_KEY]?.byId || {}).find(
      (ch) => ch.username === username,
    )
  }
}

/**
 * Fetch channel by encodedId
 */
export function channelByIdSelector(encodedId: string) {
  return (state: Slice): Channel | undefined => {
    return state[SLICE_KEY]?.byId[encodedId]
  }
}
